module.exports = __webpack_public_path__ + "img/po-bg-top.5e93a017.png";